import { createSlice } from "@reduxjs/toolkit";
import {   supportRaiseQueryThunk } from "./thunk";


export const initialState = {
  supportQueryData: [],
  supportQueryError: {
    code: null,
    message: '',
    data: null
  },
  supportQueryLoading: false,
  
  
};

const Support_Raise_Query = createSlice({
  name: "Support_Raise_Query",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(supportRaiseQueryThunk.pending, (state) => {
      state.supportQueryLoading = true ;
      state.supportQueryError = initialState.supportQueryError; 
  });
    builder.addCase(supportRaiseQueryThunk.fulfilled, (state, action) => {
        state.clientDetails = action.payload.data;
        state.supportQueryLoading = false ;
    });
    builder.addCase(supportRaiseQueryThunk.rejected, (state, action) => {
      state.supportQueryError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.supportQueryLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  ClientDetailsSuccess,
  
} = Support_Raise_Query.actions

export default Support_Raise_Query.reducer;